<template>
  <div class="device-lights-container">
    <div class="light-section" :class="{ 'full-width': !hasDongle }">
      <h3 class="section-title">{{ $t("mouse.mouseLight") }}</h3>
      <c-mouse-am35-light />
    </div>
    <div class="light-section" v-if="hasDongle">
      <h3 class="section-title">{{ $t("mouse.dongleLight") }}</h3>
      <c-dongle-light />
    </div>
  </div>
</template>
<script>
import CMouseAm35Light from "./Light.vue";
import CDongleLight from "./DongleLight.vue";
import { mapState } from "vuex";

export default {
  name: "CDeviceLightsContainer",
  components: {
    CMouseAm35Light,
    CDongleLight,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState("loader", {
      currentDevice: "currentDevice",
    }),
    // 根据当前设备代码判断是否有Dongle
    hasDongle() {
      // 设备代码列表，如果需要根据实际情况调整
      const dongleDevices = ["am35_d"]; // 这里需要替换为实际支持Dongle的设备代码
      return dongleDevices.includes(this.currentDevice.code);
    },
  },
  methods: {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.device-lights-container {
  display: grid;
  grid-template-columns: 1fr 1fr; /* 将容器分为两列，左右各占一半 */
  width: 100%; /* 使用全部父元素宽度 */
  gap: 30px;

  .light-section {
    padding: 0.28rem;
    border-radius: 8px;
    background-color: rgba(30, 30, 30, 1);
    transition: all 0.3s ease;
    min-width: 6.5rem;
    min-height: 4.5rem;
    &.full-width {
      grid-column: 1 / -1; /* 当只有一个灯效时，跨越所有列 */
    }

    .section-title {
      font-size: 20px;
      color: $primary-color;
      margin-bottom: 20px;
      text-align: center;
      font-weight: 500;
    }

    /* 统一组件字体大小和样式 */
    :deep(.param-item .name),
    :deep(.item label) {
      font-size: 18px;
      font-weight: 500;
      color: $primary-color;
    }

    :deep(.slider),
    :deep(.field),
    :deep(.md-select),
    :deep(.md-option) {
      font-size: 16px;
    }

    :deep(.item),
    :deep(.param-item) {
      margin-bottom: 20px;
    }
  }
}
</style>
